import { FallbackComponent } from './FallbackComponent';
import { getSupportedVariantName } from './getSupportedVariantName';
import { variants } from './variants';
/**
 * Returns a Styled Component variant based on the name.
 */
export const getConfiguration = (name) => {
    const variantName = getSupportedVariantName(name);
    const configuration = variants.get(variantName);
    if (!configuration) {
        if (process.env.NODE_ENV === 'development') {
            throw new Error(`Typography variant "${variantName}" has not been registered! Please consult this Common Errors section in the MIGRATION.md guide in our repository on how to fix this.`);
        }
        return {
            component: FallbackComponent,
        };
    }
    return configuration;
};
